"use client";
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Stack } from "@/components/ui/layout";
import { Text } from "@/components/ui/typography";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

function VisualEffectsPanel() {
  return (
    <Card className={cn("h-full")}>
      <CardContent className="p-4">
        <Stack spacing="md">
          <div className={cn("flex items-center gap-2")}>
            <img
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/1df7ae72b47da94399b973deed70f9cc7765a85132e762754244727c4ab9ea3e?placeholderIfAbsent=true"
              className="w-5 h-5"
              alt="Effects icon"
            />
            <Text className="font-semibold">Apply visual effects</Text>
          </div>

          <div className={cn("grid grid-cols-3 gap-2")}>
            {[
              "https://cdn.builder.io/api/v1/image/assets/TEMP/fffa5b1d8756dca2b733dcdd1f049694bdeb46c1fbd8dede414831f622c05920?placeholderIfAbsent=true",
              "https://cdn.builder.io/api/v1/image/assets/TEMP/2acc7b389941fffa4171dadb1033f65a72a91609fa6c2b7565d6ea774787cfb5?placeholderIfAbsent=true",
              "https://cdn.builder.io/api/v1/image/assets/TEMP/71d9d98396c400c2edfe65b2d75b738b76beddaee6fcd601b0f6514af2c2384e?placeholderIfAbsent=true",
              "https://cdn.builder.io/api/v1/image/assets/TEMP/299818242a050650e7c85edcba183aa561fc9d73036e349dae3570fbc0974fe6?placeholderIfAbsent=true",
              "https://cdn.builder.io/api/v1/image/assets/TEMP/8fdf873f4b59659351aea383d56d6deb2e657122b77293448def6b6ad266b507?placeholderIfAbsent=true",
              "https://cdn.builder.io/api/v1/image/assets/TEMP/89cceeba9aeb578104d1aecbb6c9c1efc1e926f55586013aca892cbcea7f690f?placeholderIfAbsent=true",
              "https://cdn.builder.io/api/v1/image/assets/TEMP/30ac340e6261e6784aa09dda3d55080a35e8f2aa5fe9da98ed77294b5c073775?placeholderIfAbsent=true",
              "https://cdn.builder.io/api/v1/image/assets/TEMP/4491e5c29b977708fce3d246fcb880dc40375fe0ae8ee42f0797706d31ad8249?placeholderIfAbsent=true",
              "https://cdn.builder.io/api/v1/image/assets/TEMP/3d22513dc8c04f50501b42bc1a47e95cdec8334b2665d0620e56326511a18f64?placeholderIfAbsent=true"
            ].map((src, i) => (
              <img
                key={i}
                src={src}
                className={cn("w-full aspect-square object-cover rounded-md cursor-pointer hover:opacity-80 transition-opacity")}
                alt={`Effect ${i + 1}`}
              />
            ))}
          </div>

          <div>
            <Text className="font-semibold mb-2">Blur and Personal Background</Text>
            <div className={cn("flex gap-2")}>
              <Button variant="outline" size="icon" className={cn("w-12 h-12")}>
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/fa0f54637bc561b2fcc7b397305cdfa35ae473e7b891ebafa2f9598a57895b44?placeholderIfAbsent=true"
                  className="w-6 h-6"
                  alt="Blur"
                />
              </Button>
              <Button variant="ghost" size="icon" className={cn("w-12 h-12")}>
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/d606c981991ffd0047c23649f121b620e70c1bcd8faa29aa1ece263e07ef582c?placeholderIfAbsent=true"
                  className="w-6 h-6"
                  alt="Background"
                />
              </Button>
            </div>
          </div>

          <Stack spacing="sm">
            {[
              { icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/1df7ae72b47da94399b973deed70f9cc7765a85132e762754244727c4ab9ea3e?placeholderIfAbsent=true", text: "Report a problem" },
              { icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/650b70aaa1939d39aa2e31260796723dfb7cd49bef73f2e1d61e173c63438e5c?placeholderIfAbsent=true", text: "Troubleshooting & help" },
              { icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/4a33e8aa7032e7888a71a035f4e84c6b7a8c1c9f6b2a6fe31d138359a835e732?placeholderIfAbsent=true", text: "Settings" }
            ].map((item, i) => (
              <Button key={i} variant="ghost" className={cn("justify-start")}>
                <img src={item.icon} className="w-4 h-4 mr-2" alt={item.text} />
                <Text className="text-sm">{item.text}</Text>
              </Button>
            ))}
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}

export default VisualEffectsPanel;
